$(document).ready(function(){
  $(document).on('click', '.menu-icon', function() {
    $(this).toggleClass('open');
    $('.header-menu-drawer').toggleClass('active');
    $('body').toggleClass('opened-drawer');
    $('.section-header').toggleClass('active-menu');
  });
});

$(document).ready(function(){
  $("#HeaderMenu-collection").click(function() {
      $('html, body').animate({
          scrollTop: parseInt($(".section-image-with-text-collection").offset().top - 85)
      }, 500);
  });
});

$(document).ready(function(){
    // Check if the URL has the anchor parameter and scroll to the section after the page loads
    if (window.location.href.indexOf("#aboutus") > -1) {
        $('html, body').animate({
            scrollTop: $(".section-image-with-text-aboutus").offset().top - 85
        }, 500);
    }

    // Click event for the desktop menu item
    $("#HeaderMenu-about-us").click(function(event) {
        event.preventDefault(); // Prevent default link behavior

        // Check if the current page is the home page
        if (window.location.pathname === "/" || window.location.pathname === "/index") {
            $('html, body').animate({
                scrollTop: $(".section-image-with-text-aboutus").offset().top - 85
            }, 500);
        } else {
            // Redirect to home page with an anchor
            window.location.href = "/#aboutus";
        }
    });

    // Click event for the mobile menu item
    $(".menu-link-about-us").click(function(event) {
        event.preventDefault(); // Prevent default link behavior

        // Close the mobile menu (drawer)
       $('#menu-icon').removeClass('open');
        $('.header-menu-drawer').removeClass('active');
        $('body').removeClass('opened-drawer');
        $('.section-header').removeClass('active-menu');

        // Scroll to the section (only if already on the home page)
        if (window.location.pathname === "/" || window.location.pathname === "/index") {
            setTimeout(function() { // Small delay to ensure smooth transition
                $('html, body').animate({
                    scrollTop: $(".section-image-with-text-aboutus").offset().top - 85
                }, 500);
            }, 300);
        } else {
            // Redirect to home page with an anchor
            window.location.href = "/#aboutus";
        }
    });
});


// $(document).ready(function(){
//   $("#HeaderMenu-contact-us").click(function() {
//       $('html, body').animate({
//           scrollTop: $(".feature-collection-section").offset().top - 85
//       }, 500);
//   });
// });

// $(document).ready(function(){
//   $("body").removeClass("scroll-menu");
//   $(".menu-link-about-us").click(function() {
//      $(".header-menu-drawer").removeClass("active");
//       $("body").removeClass("opened-drawer");
//       $("body").addClass("scroll-menu");
//     $("#menu-icon").removeClass("open");
//       $('html, body').animate({
//           scrollTop: $(".section-image-with-text-aboutus").offset().top - 85
//       }, 500);
//   });
//   $("body").removeClass("scroll-menu");
// });

$(document).ready(function(){
  $("body").removeClass("scroll-menu");
  $(".menu-link-collection").click(function() {
     $(".header-menu-drawer").removeClass("active");
      $("body").removeClass("opened-drawer");
      $("body").addClass("scroll-menu");
      $("#menu-icon").removeClass("open");
      $('html, body').animate({
          scrollTop: $(".section-image-with-text-collection").offset().top - 85
      }, 500);
  });
$("body").removeClass("scroll-menu");
});

// $(document).ready(function(){
//   $("body").removeClass("scroll-menu");
//   $(".menu-link-contact-us").click(function() {
//      $(".header-menu-drawer").removeClass("active");
//      $("body").addClass("scroll-menu");
//       $("body").removeClass("opened-drawer");
//       $("#menu-icon").removeClass("open");
//       $('html, body').animate({
//           scrollTop: $(".feature-collection-section").offset().top - 85
//       }, 500);
//   });
//   $("body").removeClass("scroll-menu");
// });

$(document).ready(function(){
  $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
        $("body").addClass("scroll-menu");
      } else {
        $("body").removeClass("scroll-menu");
      }
    });
});

function animate() {
  document.querySelectorAll('.animate-ele').forEach((animateEle) => {
    const scrollY = (window.innerHeight * 0.75) + window.scrollY;
    const offsetTop = animateEle.getBoundingClientRect().top + window.scrollY;

    console.log(scrollY, offsetTop);
    if (scrollY > offsetTop) {
      animateEle.classList.add('animated');
    }
  });
}

animate();
window.onscroll = animate;

